import { Entity, EntityProfileType } from "../types/entity";

export const isEntitySoleProp = (entity: Entity): boolean => {
    const entityType = entity.legalType;
    return !!entityType && isEntityTypeSoleProp(entityType);
};

export const isEntityCorporation = (entity: Entity): boolean => {
    const entityType = entity.legalType;
    return !!entityType && isEntityTypeCorporation(entityType);
};

export const isEntityTypeCorporation = (
    entityType: EntityProfileType,
): boolean =>
    [EntityProfileType.S_CORP, EntityProfileType.C_CORP].includes(entityType);

export const isEntityTypeSoleProp = (entityType: EntityProfileType): boolean =>
    [EntityProfileType.SOLE_PROPRIETORSHIP].includes(entityType);

export function getConsolidationGroupDisplayName({
    groupName,
    parentEntityName,
}: {
    groupName: string;
    parentEntityName: string | null | undefined;
}): string {
    const trimmedName = groupName.trim();
    const parentName = parentEntityName?.trim();
    const legacyDefaultName = parentName ? `${parentName} group` : null;

    if (parentName && trimmedName === legacyDefaultName) {
        return parentName;
    }
    return trimmedName;
}
